import HeaderPage from '../../components/header_page';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/pages/verification';
import {openVerify} from '../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';

import Unverified from './unverified';
import RedFlag from './redflag';
import Pending from './pending';
import Verified from './verified';

export default () => {
    const {wallet, button} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate();

    const onCancel = () => navigate('/');
    const onClick = () => {
        dispatch(openVerify());
    }

    return (
        <>
            <HeaderPage title={"Verification"} />

            {wallet.redflag ? <RedFlag onCancel={onCancel} onClick={onClick} button={button} /> : (
                <>
                    {wallet.verificationStatus === "verified" && <Verified onCancel={onCancel} />}
                    {wallet.verificationStatus === "unverified" && <Unverified onCancel={onCancel} onClick={onClick} button={button} />}
                    {wallet.verificationStatus === "verification-pending" && <Pending onCancel={onCancel} />}   
                </>
            )}    
        </>
    )
}